// Constants for different requests for current reducer
export default {
  areas: 'AREAS',
  area: 'AREA',
};
